import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout";
import SplashIntro from "./components/SplashIntro";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Flooring from "./pages/services/Flooring";
import InteriorFinishing from "./pages/services/InteriorFinishing";
import ArtisanPlastering from "./pages/services/ArtisanPlastering";
import Tiling from "./pages/services/Tiling";
import JohnStreet from "./pages/projects/JohnStreet";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <SplashIntro />
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/flooring" element={<Flooring />} />
            <Route path="/services/interior-finishing" element={<InteriorFinishing />} />
            <Route path="/services/artisan-plastering" element={<ArtisanPlastering />} />
            <Route path="/services/tiling" element={<Tiling />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/151-john-street" element={<JohnStreet />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors closeButton />
    </div>
  );
}

export default App;
